/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Modals\ModalConfirmRequest\ModalConfirmRequest.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday February 22nd 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday February 22nd 2024 11:33:06 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { MouseEventHandler } from "react";
import Styles from "Content/Modals/ModalMakeOffer/ModalMakeOffer.module.css";
import StylesConfirm from "Content/Modals/ModalConfirmation/ModalConfirmation.module.css";
import MyModal from "Content/Modals/MyModal";
import translator from "MultiLanguage/TranslationWrapper";

type ModalMakeOfferProps = {
    show: boolean,
    onClose: MouseEventHandler<HTMLDivElement>,
    closeModal: MouseEventHandler,
    request: Function,
    title: string,
    additionnalMessage?: string | string[] | JSX.Element[]
};

export function ModalConfirmRequest(props: ModalMakeOfferProps) {
    return (
        <MyModal closeModal={props.closeModal} show={props.show} onClose={props.onClose} addCloseCross={true} footer={(()=>{return (<></>)})()} title={props.title ?? ""} className={Styles.modalCtaStyle} >
            <div className={`${Styles.modal}`}>
                {
                    props.additionnalMessage ?
                    <div className={`${StylesConfirm.additionnalMessageBlock}`}>{typeof(props.additionnalMessage) === "string" ? <p>{props.additionnalMessage}</p> : <><p className={`${StylesConfirm.additionnalMessage}`}>{props.additionnalMessage.map((mes) => <><span>{mes}</span><br/></>)}</p></>}</div> : null
                }
                <div>
                    <button className="btn btn-danger" onClick={props.closeModal}>{translator.decode("dynamic.cancel")}</button>
                    <button className="btn btn-success ms-3" onClick={() => props.request()}>{translator.decode("dynamic.confirm")}</button>
                </div>
            </div>
        </MyModal>
    )
}
